<template>
  <v-dialog
    :value="enableDialog"
    width="500"
    persistent
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="vehicleFormValidation"
    >
      <v-form>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>{{ targetId ? '車両編集' : '車両追加' }}</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|alpha_num_only|max:10"
                  class="requiredMark"
                  name="コード"
                >
                  <v-text-field
                    v-model="forms.code"
                    :error-messages="errors"
                    dense
                    label="コード"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）S001"
                    required
                  >
                    <template v-slot:label>
                      <span>コード</span>
                      <span class="ml-1">
                        ({{ forms.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:15"
                  class="requiredMark"
                  name="車両名"
                >
                  <v-text-field
                    v-model="forms.name"
                    :error-messages="errors"
                    dense
                    label="車両名"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）4tトラック　1号車"
                    required
                  >
                    <template v-slot:label>
                      <span>車両名</span>
                      <span class="ml-1">
                        ({{ forms.name?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="max:15"
                  name="車両番号"
                >
                  <v-text-field
                    v-model="forms.number"
                    :error-messages="errors"
                    dense
                    label="車両番号"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）横浜111あ111"
                  >
                    <template v-slot:label>
                      <span>車両番号</span>
                      <span class="ml-1">
                        ({{ forms.number?.length || 0 }} / 15)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                  name="表示順"
                >
                  <v-text-field
                    v-model="forms.sort_priority"
                    :error-messages="errors"
                    dense
                    :show-size="1000"
                    label="表示順"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    reverse
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      inputtedKeyword: null,
      forms: {
        id: null,
        code: null,
        name: null,
        number: null,
        sort_priority: null,
      },
    }
  },
  computed: {
  },
  watch: {
    enableDialog (value) {
      this.$nextTick(() => this.$refs.vehicleFormValidation.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (value) {
        if (this.targetId) {
          this.searchEditVehicle()
        } else {
          this.searchNewVehicle()
        }
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterVehicle', {
      newVehicle: 'new',
      editVehicle: 'edit',
      createVehicle: 'create',
      updateVehicle: 'update',
    }),
    /**
     * 新規時表示情報取得
     */
    searchNewVehicle () {
      this.newVehicle().then((content) => {
        this.forms = content
      })
    },
    /**
     * 編集時表示情報取得
     */
    searchEditVehicle () {
      this.editVehicle({ id: this.targetId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
    * 登録ボタン クリックイベント
    */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.vehicleFormValidation.validate().then((result) => {
        if(result){
          $self.SendRegistrationInformation()
        }
      })
    },
    SendRegistrationInformation(){
      if (this.targetId) {
        this.updateVehicle({ id: this.targetId, params: this.forms}).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        this.createVehicle({ params: this.forms }).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
  }
}
</script>

<style scoped>
</style>
